/* 7df8e5121ea190a93f07fb086624d2864fc4b739
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type UnityCommunicationSubscriptionVariables = Types.Exact<{
  jwt: Types.Scalars['String'];
}>;


export type UnityCommunicationSubscription = (
  { __typename?: 'Subscription' }
  & { unityCommunication: (
    { __typename?: 'Communication' }
    & Pick<Types.Communication, 'code' | 'message'>
  ) }
);

export type GetIslandsMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type GetIslandsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'getUnityIslands'>
);


export const UnityCommunicationDocument = gql`
    subscription UnityCommunication($jwt: String!) {
  unityCommunication(jwt: $jwt) {
    code
    message
  }
}
    `;

/**
 * __useUnityCommunicationSubscription__
 *
 * To run a query within a React component, call `useUnityCommunicationSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUnityCommunicationSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnityCommunicationSubscription({
 *   variables: {
 *      jwt: // value for 'jwt'
 *   },
 * });
 */
export function useUnityCommunicationSubscription(baseOptions: Apollo.SubscriptionHookOptions<UnityCommunicationSubscription, UnityCommunicationSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<UnityCommunicationSubscription, UnityCommunicationSubscriptionVariables>(UnityCommunicationDocument, options);
      }
export type UnityCommunicationSubscriptionHookResult = ReturnType<typeof useUnityCommunicationSubscription>;
export type UnityCommunicationSubscriptionResult = Apollo.SubscriptionResult<UnityCommunicationSubscription>;
export const GetIslandsDocument = gql`
    mutation getIslands {
  getUnityIslands
}
    `;
export type GetIslandsMutationFn = Apollo.MutationFunction<GetIslandsMutation, GetIslandsMutationVariables>;

/**
 * __useGetIslandsMutation__
 *
 * To run a mutation, you first call `useGetIslandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetIslandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getIslandsMutation, { data, loading, error }] = useGetIslandsMutation({
 *   variables: {
 *   },
 * });
 */
export function useGetIslandsMutation(baseOptions?: Apollo.MutationHookOptions<GetIslandsMutation, GetIslandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetIslandsMutation, GetIslandsMutationVariables>(GetIslandsDocument, options);
      }
export type GetIslandsMutationHookResult = ReturnType<typeof useGetIslandsMutation>;
export type GetIslandsMutationResult = Apollo.MutationResult<GetIslandsMutation>;
export type GetIslandsMutationOptions = Apollo.BaseMutationOptions<GetIslandsMutation, GetIslandsMutationVariables>;